module.exports = __webpack_public_path__ + "static/media/dull burg circle.7fc23c8b.png";